(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["g4-pdp-enhancement"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-g4-enhancement]').forEach(element => {
    if (element.dataset.ready) return;
    const root = document.getElementById(element.dataset.section);
    if (!root) return;
    element.dataset.ready = 'true';
    const variants = JSON.parse(element.querySelector('[data-g4-variants]').textContent);
    const price = root.querySelector('[data-product-price]');
    const tax = price?.querySelector('.tax')?.cloneNode(true);
    const applyVariant = (variant) => {
      if (!variant || !variants[String(variant.id)]) return;
      const value = variants[String(variant.id)];
      const label = root.querySelector('[data-add-to-cart] [data-add-to-cart-text]');
      if (label) {
        label.dataset.defaultText = value.label;
        if (value.available) label.textContent = value.label;
      }
      const dispatch = root.querySelector('[data-g4-dispatch]');
      if (dispatch) dispatch.textContent = value.dispatch;
      if (tax && price && !price.querySelector('.tax')) price.append(tax.cloneNode(true));
    };
    root.addEventListener('variantChange', event => {
      requestAnimationFrame(() => applyVariant(event.detail.variant));
    });
    const gallery = root.querySelector('.product__main-photos');
    const nav = element.querySelector('.g4-pdp__media-nav');
    const photos = root.querySelector('[data-product-photos]');
    if (gallery && nav && photos) {
      gallery.append(nav);
      const updateCounter = () => {
        const slides = Array.from(photos.querySelectorAll('.product-main-slide'));
        const index = slides.findIndex(slide => slide.classList.contains('is-selected'));
        const counter = nav.querySelector('[data-g4-counter]');
        const text = `${Math.max(0,index) + 1} / ${slides.length}`;
        if (counter.textContent !== text) counter.textContent = text;
        nav.hidden = slides.length < 2;
      };
      const step = direction => {
        const dots = Array.from(photos.querySelectorAll('.flickity-page-dots .dot'));
        const index = dots.findIndex(dot => dot.classList.contains('is-selected'));
        if (dots.length) dots[(Math.max(0,index) + direction + dots.length) % dots.length].click();
      };
      nav.querySelector('[data-g4-previous]').addEventListener('click', () => step(-1));
      nav.querySelector('[data-g4-next]').addEventListener('click', () => step(1));
      new MutationObserver(updateCounter).observe(photos, {subtree:true,attributes:true,attributeFilter:['class'],childList:true});
      updateCounter();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
